export default "__VITE_ASSET__3U09RSTb__"